/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L8Inputs */

const en_mk_sec_pg_l8 = /** @type {(inputs: Mk_Sec_Pg_L8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOC 2 / ISO 27001 certification`)
};

const id_mk_sec_pg_l8 = /** @type {(inputs: Mk_Sec_Pg_L8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertifikasi SOC 2 / ISO 27001`)
};

/**
* | output |
* | --- |
* | "SOC 2 / ISO 27001 certification" |
*
* @param {Mk_Sec_Pg_L8Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l8 = /** @type {((inputs?: Mk_Sec_Pg_L8Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L8Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l8(inputs)
	return en_mk_sec_pg_l8(inputs)
});